module.exports = __webpack_public_path__ + "static/img/earnRsBg.71dd6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/earnRsBg.png
// module id = PV/H
// module chunks = 0